import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  Item,
  Money,
  EquipmentPack,
  BasicItem,
  Ammunition,
  MagicItemKeyword,
  PseudoItem,
  Spell,
  // CharacterRecipe,
  // Recipe,
  SpellLimitation,
  Campaign,
  CharacterInventory,
  CampaignInventory,
  // CampaignRecipe,
} from "@dndModels";
import { ALL_DRAGONS, CREATURE_TYPES } from "@dndModels/Constants";

import API from "@utilities/smart_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';
import { makeStyles } from "@utilities/theme_utilities";

import StringBox from "@components/input/strings/StringBox";

import ViewItem from "@dndComponents/display/ViewItem";
import ItemDetails from "@dndComponents/equipment/ItemDetails";
import CharacterManageInventoryItemMIK from "@dndComponents/character/inventory/manage/CharacterManageInventoryItemMIK";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectSpellBox from "@dndComponents/select/SelectSpellBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

interface Props {
  char: Character | Campaign;
  inventory?: CharacterInventory | CampaignInventory;
  expanded: boolean;
  log_it?: boolean;
  item: Item | EquipmentPack; // | PseudoItem
  all_base_items: Item[];
  // When set, items are passed here instead of being added to the inventory.
  onAddItem?: (item: PseudoItem, count: number) => void;
  onExpand: () => void;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterManageInventoryItem({
  char,
  inventory,
  expanded,
  log_it,
  item,
  all_base_items,
  onAddItem,
  onExpand,
}: Props) {
  if (log_it) {
    debugger;
  }
  const use_pseudo_item = (item instanceof Item ? new PseudoItem(item) : new PseudoItem()); // item instanceof PseudoItem ? item.clone() : 
  let possible_miks: MagicItemKeyword[] = [];
  if (!(item instanceof EquipmentPack)) {
    const possible_mik_ids = use_pseudo_item.base_item?.possible_mik_ids??[];
    possible_miks = data_util.magic_item_keywords.filter(o => possible_mik_ids.includes(o._id));
  }
  // const [fetched, setFetched] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [campaign_recipes_loading, setCampaignRecipesLoading] = useState(false);
  const [count, setCount] = useState(use_pseudo_item.base_item instanceof BasicItem || use_pseudo_item.base_item instanceof Ammunition ? +use_pseudo_item.base_item.bundle_size : 1);
  const [prev_expanded, setExpanded] = useState(expanded);
  const [pseudo_item, setPseudoItem] = useState(use_pseudo_item);
  // const [recipe_options, setRecipeOptions] = useState(use_pseudo_item.recipes);
  const [extra_string, setExtraString] = useState("");
  const [extra_spell, setExtraSpell] = useState<Spell | null>(null);
  const [ping, setPing] = useState(false);

  useEffect(() => {
    if (expanded !== prev_expanded) {
      setExpanded(expanded);
      const finish = () => {
        const new_pseudo_item = item instanceof Item ? new PseudoItem(item) : new PseudoItem();
        // let use_recipes: Recipe[] = [];
        // if (char.campaign) {
        //   let the_recipes: Recipe[] = [];
        //   if (pseudo_item.base_item) {
        //     const for_id = pseudo_item.base_item._id;
        //     const campaign_recipes = char.campaign.campaign_recipes.find(o => o.for_type === "Item" && o.for_id === for_id);
        //     if (campaign_recipes) {
        //       the_recipes = campaign_recipes.recipes;
        //     }
        //     if (the_recipes.length === 0) {
        //       the_recipes = pseudo_item.base_item.recipes;
        //     }
        //   }
        //   for (const mik of pseudo_item.magic_item_keywords) {
        //     let new_recipes: Recipe[] = [];
        //     const campaign_recipes = char.campaign.campaign_recipes.find(o => o.for_type === "Magic Item Keyword" && o.for_id === mik._id);
        //     if (campaign_recipes) {
        //       if (the_recipes.length === 0) {
        //         new_recipes = campaign_recipes.recipes;
        //       } else {
        //         for (const recipe of the_recipes) {
        //           for (const campaign_recipe of campaign_recipes.recipes) {
        //             const new_recipe = recipe.clone();
        //             new_recipe.merge(campaign_recipe);
        //             new_recipes.push(new_recipe);
        //           }
        //         }
        //       }
        //     }
        //     if (new_recipes.length === 0) {
        //       if (the_recipes.length === 0) {
        //         new_recipes = mik.recipes;
        //       } else {
        //         for (const recipe of the_recipes) {
        //           for (const campaign_recipe of mik.recipes) {
        //             const new_recipe = recipe.clone();
        //             new_recipe.merge(campaign_recipe);
        //             new_recipes.push(new_recipe);
        //           }
        //         }
        //       }
        //     }
        //     the_recipes = new_recipes;
        //   }
        //   use_recipes = the_recipes;
        // }
        // if (use_recipes.length === 0) {
        //   use_recipes = new_pseudo_item.recipes;
        // }
        // setRecipeOptions(use_recipes);
        setPseudoItem(new_pseudo_item);
      }
      
      // if (char.campaign && !char.campaign.campaign_recipes_loaded) {
      //   setCampaignRecipesLoading(true);
      //   api.getObjects({ data_type: "campaign_recipe", filter: { campaign_id: char.campaign_id } }).then(res => {
      //     if (res && char.campaign) {
      //       char.campaign.campaign_recipes_loaded = true;
      //       char.campaign.campaign_recipes = res as CampaignRecipe[];
      //     }
      //     finish();
      //     setCampaignRecipesLoading(false);
      //   });
      // } else {
      finish();
      // }
    }
    // eslint-disable-next-line
  }, [expanded, prev_expanded]);
  
  const useRowStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main
      },
    });
  });
  
  const addItem = async ({ 
    cost = new Money(),
    count = 1
  }: { 
    cost?: Money,
    count?: number
  }) => {
    if (onAddItem) {
      if (item instanceof EquipmentPack) {
        for (const ep_item of item.items) {
          const the_item = all_base_items.find(o => o._id === ep_item.item_id);
          if (the_item) {
            onAddItem(new PseudoItem(the_item), ep_item.count);
          }
        }
      } else {
        pseudo_item.extra = extra_string;
        pseudo_item.extra_spell = extra_spell;
        onAddItem(pseudo_item, count);
      }
      setPing(!ping);
      return;
    }
    if (item instanceof EquipmentPack) {
      for (const ep_item of item.items) {
        const the_item = all_base_items.find(o => o._id === ep_item.item_id);
        if (the_item) {
          await connect_util.addItem({ char, item: the_item, count: ep_item.count });
        }
      }
    } else {
      pseudo_item.extra = extra_string;
      pseudo_item.extra_spell = extra_spell;
      await connect_util.addItem({ char, item: pseudo_item, count });
    }
    if (inventory) {
      inventory.money.subtract(cost);
    }
    char.subscription_holder.itemsChanged();
    setPing(!ping);
  }

  const renderMIKs = () => {
    if (pseudo_item.base_item instanceof Item) {
      return (
        <>
          { possible_miks.sort((a, b) => {
              if (a.min_rarity > b.min_rarity) {
                return 1;
              } else {
                if (a.min_rarity === b.min_rarity) {
                  return a.name.localeCompare(b.name);
                } else {
                  return -1;
                }
              }
            }).map((mik, key) => {
            return (
              <Grid size={12} key={key}>
                <CharacterManageInventoryItemMIK 
                  pseudo_item={pseudo_item} 
                  char={char}
                  mik={mik} 
                  onChange={(changed: PseudoItem) => {
                    // setRecipeOptions(changed.recipes);
                    setPseudoItem(changed);
                  }}
                />
              </Grid>
            );
          })}
        </>
      );
    }
  }

  // const renderRecipes = () => {
  //   if (item instanceof EquipmentPack) {
  //     return null;
  //   } else {
  //     if (recipe_options.length === 1) {
  //       const true_id = recipe_options[0].true_id;
  //       const known_recipe = char.recipes_known.find(o => o.recipe.true_id === true_id);
  //       return (
  //         <Grid
  //           size={{
  //             xs: 12
  //           }}>
  //           <ButtonBox
  //             name={ known_recipe ? "Recipe Known" : "Learn Recipe" }
  //             disabled={known_recipe !== undefined}
  //             onClick={() => {
  //               const new_recipe = new CharacterRecipe();
  //               new_recipe.recipe = recipe_options[0].clone();
  //               new_recipe.pseudo_item = pseudo_item.clone();
  //               // new_recipe.recipe = new_recipe.pseudo_item.recipe;
  //               char.recipes_known.push(new_recipe);
  //               char.subscription_holder.itemsChanged();
  //             }}
  //           />
  //         </Grid>
  //       );
  //     } else if (recipe_options.length > 0) {
  //       return (
  //         <>
  //           <Grid
  //             className="header"
  //             size={{
  //               xs: 12
  //             }}>Recipes</Grid>
  //           { recipe_options.map((recipe, key) => {
  //             const known_recipe = char.recipes_known.find(o => o.recipe.true_id === recipe.true_id);
  //             return (
  //               <Grid
  //                 key={key}
  //                 size={{
  //                   xs: 12
  //                 }}>
  //                 <ButtonBox
  //                   name={ known_recipe ? `${recipe.name} Recipe Known` : `Learn Recipe ${recipe.name}` }
  //                   disabled={known_recipe !== undefined}
  //                   onClick={() => {
  //                     const new_recipe = new CharacterRecipe();
  //                     new_recipe.recipe = recipe.clone();
  //                     new_recipe.pseudo_item = pseudo_item.clone();
  //                     // new_recipe.recipe = new_recipe.pseudo_item.recipe;
  //                     char.recipes_known.push(new_recipe);
  //                     char.subscription_holder.itemsChanged();
  //                   }}
  //                 />
  //               </Grid>
  //             );
  //           })}
  //         </>
  //       );
  //     }
  //     return null;
  //   }
  // }
  
  const { classes: rowClasses, cx: cx2 } = useRowStyles();
  // if (item.name.includes("Case, map or scroll")) {
  //   debugger;
  // }
  // In expanded, add count select for everything, with add and buy options
  // If stackable, change main add and buy options to use bundle size, with bundle size in parentheses
  let expanded_content: any = null;
  const cost_for_count = new Money();
  const bundle_cost = new Money();
  let bundle_size = 1;
  const disabled = !api.online || !(api.user && (api.user._id === char.owner_id || api.user.admin));
  // if (item.name.includes("Majesty")) {
  //   debugger;
  // }
  if (prev_expanded) {
    expanded_content = (
      <Grid size={12} style={{ border: "1px solid" }}
        container spacing={0} direction="column">
        <DisplayStringWithReplacements display_string={ item.description } />
      </Grid>
    );
  }
  if (item instanceof EquipmentPack) {
    cost_for_count.copyGoldValue(item.cost * count);
  } else {
    // if (prev_expanded) {
    //   debugger;
    // }
    if (pseudo_item.magic_item_keywords.length === 0) {
      cost_for_count.copyGoldValue(item.cost * count);
      bundle_size = (item instanceof BasicItem || item instanceof Ammunition) ? +item.bundle_size : 1;
      bundle_cost.copyGoldValue(item.cost * bundle_size);
    }
    if (prev_expanded) {
      // if (campaign_recipes_loading) {
      //   expanded_content = (<LoadingBox />);
      // } else {
      const cfc_gold_value = cost_for_count.gold_value();
      console.log(count);
      expanded_content = (
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ border: "1px solid", padding: "4px", backgroundColor: "black" }}
          size={12}>
          <Grid size={12}>
            <ItemDetails character={char} item={item instanceof PseudoItem && item.base_item instanceof Item ? pseudo_item : item} />
          </Grid>
          { pseudo_item.base_item instanceof Item && renderMIKs() }
          <Grid
            style={{ margin: "auto" }}
            size={8}>
            <StringBox 
              name="Count"
              value={`${count}`}
              type="number"
              disabled={disabled}
              onChange={(value: string) => {
                setCount(+value);
              }}
            />
          </Grid>
          <Grid
            style={{ margin: "auto" }}
            size={2}>
            { inventory && cfc_gold_value > 0 && !onAddItem &&
              <DandDButtonBox
                name={cost_for_count.toString()}
                disabled={ cfc_gold_value > inventory.money.gold_value() } 
                onClick={() => {
                  // debugger;
                  addItem({ cost: cost_for_count, count });
                }}
              />
            }
          </Grid>
          <Grid
            style={{ margin: "auto" }}
            size={2}>
            <DandDButtonBox
              name={`Add${ count > 1 ? ` (${count})` : ""}`}
              log_it
              onClick={() => {
                // debugger;
                addItem({ count });
              }}
            />
          </Grid>
          {/* { renderRecipes() } */}
        </Grid>
      );
      // }
    }
  }

  const renderInInv = () => {
    if (onAddItem || !inventory) {
      return null;
    }
    // if (item.name.includes("Dagger")) {
    //   debugger;
    // }
    if (item instanceof PseudoItem) {
      const in_inv = inventory.items.filter(o => o.pseudo_item_id === item.id).map(o => o.count).reduce((a, b) => a + b, 0);
      if (in_inv > 0) {
        return (
          <Grid size={12} className="small_label gray centered">
            { in_inv } in Inventory
          </Grid>
        );
      }
    } else if (item instanceof Item) {
      const in_inv = inventory.items.filter(o => o.base_item_id === item._id).map(o => o.count).reduce((a, b) => a + b, 0);
      if (in_inv > 0) {
        return (
          <Grid size={12} className="small_label gray centered">
            { in_inv } in Inventory
          </Grid>
        );
      }
    }
    return null;
  }

  if (!(item instanceof Item) || item.extra_base_type === "" || item.extra_base_type === "None") {
    const gold_value = bundle_cost.gold_value();
    // debugger;
    return (
      <Grid container spacing={0} direction="row"
        className={cx2(rowClasses.root)}>
        <Grid size={8} className="clickable padded"
          container spacing={0} direction="row"
          onClick={() => {
            onExpand();
          }}>
          <Grid size={12}>
            <ViewItem item={item} character={char instanceof Character ? char : undefined} />
          </Grid>
          { possible_miks.length > 0 &&
            <Grid size={12} className="small_label gray">
              { possible_miks.map(mik => char_util.getUseName(mik)).join(", ") }
            </Grid>
          }
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          <Grid container spacing={0} direction="row">
            <Grid
              style={{ margin: "auto" }}
              size={{
                xs: 6
              }}>
              { inventory && gold_value > 0 && !onAddItem &&
                <DandDButtonBox
                  name={bundle_cost.toString()}
                  disabled={ gold_value > inventory.money.gold_value() } 
                  onClick={() => {
                    // debugger;
                    addItem({ cost: bundle_cost, count: bundle_size });
                  }}
                />
              }
            </Grid>
            <Grid
              style={{ margin: "auto" }}
              size={{
                xs: 6
              }}>
              <DandDButtonBox
                name={`Add${ bundle_size > 1 ? ` (${bundle_size})` : ""}`}
                onClick={() => {
                  // debugger;
                  addItem({ count: bundle_size });
                }}
              />
            </Grid>
            { renderInInv() }
          </Grid>
        </Grid>
        { expanded_content }
      </Grid>
    );
  } else if (item.extra_base_type === "Spell") {
    const extra_base_limits = item.extra_base_limits as { levels: string[], schools: string[], onSpellList: string[] };
    let spell_levels: number[] = [];
    if (extra_base_limits.levels.includes("Any")) {
      spell_levels = [0,1,2,3,4,5,6,7,8,9];
    } else {
      spell_levels = extra_base_limits.levels.map(o => {
        if (o === "Cantrip") {
          return 0;
        } else {
          return +o;
        }
      });
    }
    const spells = data_util.spells.filter(o => 
      spell_levels.includes(o.level) && 
      (extra_base_limits.schools.includes("Any") || 
        extra_base_limits.schools.includes(o.school))
    );
    const spell_limit = new SpellLimitation();
    spell_limit.spell_ids = spells.map(o => o._id);
    return (
      <>
        <Grid container spacing={0} direction="row"
          className={cx2(rowClasses.root)}>
          <Grid
            size={{
              xs: 4
            }}><ViewItem item={item} /></Grid>
          <Grid
            size={{
              xs: 6
            }}>
            <SelectSpellBox 
              name="Spell"
              value={extra_spell?._id??""}
              spell_limit={spell_limit}
              // specific_spell_ids={spells.map(o => o._id)}
              onChange={(changed: string) => {
                const spell = data_util.spells.find(o => o._id === changed);
                if (spell) {
                  setExtraSpell(spell);
                }
                setExtraString(changed);
              }}
            />
          </Grid>
          <Grid
            style={{ margin: "auto" }}
            size={{
              xs: 2
            }}>
            <DandDButtonBox
              name={`Add${ bundle_size > 1 ? ` (${bundle_size})` : ""}`}
              disabled={ extra_string === "" || extra_spell === null }
              onClick={() => {
                // debugger;
                addItem({ count: bundle_size });
              }}
            />
          </Grid>
          { expanded_content }
        </Grid>
      </>
    );
  } else {
    let extra_options: string[] = [];
    if (item.extra_base_type === "Dragon Breed") {
      const extra_base_limits = item.extra_base_limits as string[];
      extra_options = extra_base_limits.length > 0 ? extra_base_limits : ALL_DRAGONS;
    } else if (item.extra_base_type === "Creature Type") {
      const extra_base_limits = item.extra_base_limits as string[];
      extra_options = extra_base_limits.length > 0 ? extra_base_limits : CREATURE_TYPES;
    }
    return (
      <>
        <Grid container spacing={0} direction="row"
          className={cx2(rowClasses.root)}>
          <Grid
            className="clickable padded"
            onClick={() => { onExpand() }}
            size={{
              xs: 4
            }}>
            <ViewItem item={item} character={char instanceof Character ? char : undefined} />
          </Grid>
          <Grid
            size={{
              xs: 6
            }}>
            <SelectStringBox
              name={item.extra_base_type}
              options={extra_options}
              value={extra_string}
              onChange={setExtraString}
            />
          </Grid>
          <Grid
            size={{
              xs: 2
            }}>
            <Grid container spacing={0} direction="row">
              <Grid
                style={{ margin: "auto" }}
                size={{
                  xs: 12
                }}>
                <DandDButtonBox
                  name={`Add${ bundle_size > 1 ? ` (${bundle_size})` : ""}`}
                  disabled={ extra_string === "" }
                  onClick={() => {
                    // debugger;
                    addItem({ count: bundle_size });
                  }}
                />
              </Grid>
              { renderInInv() }
            </Grid>
          </Grid>
          { expanded_content }
        </Grid>
      </>
    );
  }
}
